import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { VantaAuthService } from '../../core/services/vantaAuthService';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  private refreshTokenObservable?: Observable<any>;

  public constructor(private readonly authService: VantaAuthService) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(catchError((error) => {
      if (!(error instanceof HttpErrorResponse)) {
        return throwError(() => error);
      }

      if (error.status !== 401) {
        return throwError(() => error);
      }

      return this.refreshToken().pipe(switchMap(() => next.handle(request.clone())));
    }));
  }

  private refreshToken(): Observable<any> {
    if (this.refreshTokenObservable) {
      return this.refreshTokenObservable;
    }

    return this.refreshTokenObservable = this.authService.refreshTokens()
      .pipe(catchError((error) => {
        this.authService.login();
        return throwError(() => error);
      }))
      .pipe(finalize(() => this.refreshTokenObservable = undefined));
  }
}
